import styled from 'styled-components';
import GridContainer from '@ertelecom/ui-react/components/layouts/gridContainer';

export const Wrapper = styled.form`
    display: block;
    padding: 50px 0;
    @media (max-width: 950px) {
        padding-top: 20px;
    }
`;

export const Container = styled(GridContainer)`
    align-items: flex-end;
    @media (max-width: 950px) {
        flex-direction: column-reverse;
    }
`;

export const Check = styled.div`
    display: block;
    width: 863px;
    @media (max-width: 1599px) {
        width: 700px;
    }
    @media (max-width: 1279px) {
        width: 450px;
    }
    @media (max-width: 950px) {
        width: 100%;
    }
`;
export const Image = styled.div`
    display: block;
    width: calc(100% - 863px);
    padding-bottom: 60px;
    img {
        display: block;
        max-width: 100%;
        margin-left: auto;
    }
    @media (max-width: 1599px) {
        width: calc(100% - 700px);
    }
    @media (max-width: 1279px) {
        width: calc(100% - 450px);
    }
    @media (max-width: 950px) {
        width: 100%;
        padding-bottom: 0;
    }
`;
